import React, { useState } from "react";
import styles from "./index.module.scss";
import { Link } from "react-router-dom";
import { Button } from "../../components";
import Sound from "react-sound";

function StoryBoard() {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div
        className={styles.heroContainer}
        onClick={() => {
          setShowDialog(true);
        }}
      ></div>
      <Sound url={"bgm.mp3"} playStatus={"PLAYING"} volume={100} loop={true} />
      {showDialog && (
        <div className={styles.popup}>
          <div className={styles.vdeo}>
            <h2 onClick={() => setShowDialog(false)}>Vishwaroopa Darshana</h2>
            <video
              src="https://res.cloudinary.com/dxuiu1h8i/video/upload/v1624502479/pachasi/WhatsApp_Video_2021-06-24_at_00.08.34_qaorb2.mp4"
              controls
            ></video>
            <Link to="login">
              <Button name="Next" />
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default StoryBoard;
